var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_399_2372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19628 2.19086C4.43189 2.19086 2.19092 4.43183 2.19092 7.19622C2.19092 9.96061 4.43189 12.2016 7.19628 12.2016C9.96067 12.2016 12.2016 9.96061 12.2016 7.19622C12.2016 4.43183 9.96067 2.19086 7.19628 2.19086ZM0.424316 7.19622C0.424316 3.45617 3.45623 0.424255 7.19628 0.424255C10.9363 0.424255 13.9682 3.45617 13.9682 7.19622C13.9682 10.9363 10.9363 13.9682 7.19628 13.9682C3.45623 13.9682 0.424316 10.9363 0.424316 7.19622ZM6.31298 4.84075C6.31298 4.35292 6.70845 3.95745 7.19628 3.95745H7.20217C7.69 3.95745 8.08547 4.35292 8.08547 4.84075C8.08547 5.32859 7.69 5.72405 7.20217 5.72405H7.19628C6.70845 5.72405 6.31298 5.32859 6.31298 4.84075ZM7.19628 6.31292C7.68411 6.31292 8.07958 6.70839 8.07958 7.19622V9.55169C8.07958 10.0395 7.68411 10.435 7.19628 10.435C6.70845 10.435 6.31298 10.0395 6.31298 9.55169V7.19622C6.31298 6.70839 6.70845 6.31292 7.19628 6.31292Z",
    fill: "#332E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_2372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.d6c1702712c0937b4ba7b19fa928b1b1.svg";
export { ForwardRef as ReactComponent };